<template>
  <div style="display: flex; justify-content: space-between; gap: 0.5rem">
    <NxMoney
      :labelText="labelText"
      id="valor"
      :value="localValue"
      @update:value="handleValueUpdate"
    ></NxMoney>
  </div>
</template>

<script>
import NxMoney from '@/components/nexum/components/inputs/NxMoney.vue'
import { useReactiveModelMixin } from '../../mixins'

export default {
  name: 'NxInputMoney',
  mixins: [useReactiveModelMixin('value')],
  props: {
    labelText: {
      type: String,
      default: 'Valor:'
    }
  },
  components: { NxMoney },
  methods: {
    handleValueUpdate (val) {
      this.localValue = val
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/nexum/components/custom-inputs/NxInputMoney.vue